import { language } from '@/ui/i18n';

export function formatDate(date: string) {
  const dateObject = new Date(date);
  return dateObject.toLocaleDateString(language);
}
